import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import LoadingIndicator from "../components/LoadingIndicator";
import { redirectToCheckout } from "../store/prypool_products/operations";
import { isFetchingSessionId } from "../store/prypool_products/selectors";
import { useDispatch } from "react-redux";
import { SITE_URL, THANK_YOU_PAGE } from "../config";
import { useLocation } from "react-router-dom";
import { isLoggedIn, loggedInUserGuid } from "../store/iam/selectors";
import { fetchUser } from "../store/users/operations";
import { getUserWithId } from "../store/users/selectors";
import GrannboxLogin from "./GrannboxLogin";
import GrannboxRegister from "./GrannboxRegister";
import GrannboxForgotPassword from "./GrannboxForgotPassword";
import LanguageSelector from "../components/LanguageSelector/LanguageSelector";
import ihopaLogo from "../styles/images/logo-ihopa-new.svg";
import Div100vh from "react-div-100vh";
import "../styles/grannboxOnboarding.scss";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function PurchasePackage(props) {
  let query = useQuery();
  let packages = query.getAll("pid");
  const disableTrial = query.getAll("dt");
  const [activePage, setPage] = useState(""); //login | register | recover_password
  const dispatch = useDispatch();
  const isLogged = useSelector(isLoggedIn);
  const myGuid = useSelector(loggedInUserGuid);
  const fetchingSessionId = useSelector(isFetchingSessionId);
  const myProfile = useSelector((state) => getUserWithId(state, myGuid));

  const goToCheckout = (stripe_cus_id) => {
    const payload = {
      cus_id: stripe_cus_id,
      price_ids: packages,
      success_url: THANK_YOU_PAGE,
      cancel_url: SITE_URL,
    };
    if (disableTrial && disableTrial.length) {
      payload["dt"] = true;
    }
    dispatch(redirectToCheckout(payload));
  };

  useEffect(() => {
    if (!isLogged) {
      setPage("register");
    }
    isLogged && dispatch(fetchUser(myGuid));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLogged]);

  useEffect(() => {
    myProfile && myProfile.stripe_cus_id && dispatch(goToCheckout(myProfile.stripe_cus_id));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [myProfile]);

  if (!activePage || fetchingSessionId) {
    return <LoadingIndicator />;
  }
  return (
    <>
      <Div100vh className="grannbox-onboarding-wrapper">
        <div className="grannbox-form-wrapper">
          <div className="grannbox-logo">
            <img src={ihopaLogo} alt="ihopa logo" />
            <LanguageSelector />
          </div>
          {activePage === "login" && <GrannboxLogin goTo={setPage} />}
          {activePage === "register" && <GrannboxRegister goTo={setPage} />}
          {activePage === "recover_password" && <GrannboxForgotPassword goTo={setPage} />}
        </div>
      </Div100vh>
    </>
  );
}
